import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";

// Utils
import dataHandler from "@Utils/dataHandler";

// Modals
import SettingCrud from "./Modals/SettingCrud";

// Styles
import styles from "./styles.module.css";

const Company = ({ dispatch, userName, companyName }) => {
	// SettingCrud
	const [tableValue, setTableValue] = useState([]);
	const [openSettingCrud, setOpenSettingCrud] = useState(false);
	const [modalOption, setModalOption] = useState("");

	// IKTable
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const companyPromise = dataHandler({
				dispatch,
				url: "companies",
				params: defaultParams,
			});
			const [companyResponse] = await Promise.all([companyPromise]);
			setFilteredCount(companyResponse.count);
			setFilteredItems(companyResponse.items);
		})();
	}, []);

	// modal handler
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenSettingCrud(true);
	};

	// table Handler
	const handleButton = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	const setRowStyle = (item) => {
		if (!item.isActive) {
			return { backgroundColor: "rgba(255, 0, 0, 0.24)" };
		}
		return null;
	};

	// data handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "companies", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}
	};

	const refresh = async () => {
		const profilesResponse = await dataHandler({
			dispatch,
			url: "companies",
			params: defaultParams,
		});
		setFilteredCount(profilesResponse.count);
		setFilteredItems(profilesResponse.items);
	};
	return (
		<Screen hasHeader hasSidebar headerTitle="Maestro Compañía">
			<div className={styles.container}>
				<IkTable
					data={filteredItems}
					disabled={modalOption === "Watch"}
					columns={[
						{
							label: "Acciones",
							action: [{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" }],
							dataPosition: "center",
							width: 1,
							canFilter: false,
							canSort: false,
						},
						{
							label: "Activa",
							key: "isActive",
							format: "boolean",
							dataPosition: "center",
							boolLabels: { true: "Si", false: "No" },
							width: 1,
						},
						{
							label: "ID",
							key: "id",
							format: "string",
							dataPosition: "center",
							width: 1,
						},

						{
							label: "Nombre",
							key: "name",
							format: "string",
							headerPosition: "center",
							width: 3,
						},
						{
							label: "Límite Usuario",
							key: "settings.userLimit",
							canFilter: false,
							format: "blankZero",
							dataPosition: "center",
							width: 1,
						},
						{
							label: "Cant. Canales",
							key: "channels",
							canFilter: false,
							format: "blankZero",
							dataPosition: "center",
							width: 1,
						},
						{
							label: "Tiempo Sesión",
							key: "settings.sessionTimeout",
							canFilter: false,
							format: "blankZero",
							headerPosition: "left",
							width: 15,
						},
					]}
					totalRows={filteredCount}
					filteredPrintData={filteredPrintData}
					defaultParams={defaultParams}
					dataHandler={handlerData}
					handlerTable={handleButton}
					addButton={{ label: "Agregar" }}
					searcher={{ width: "40rem" }}
					setRowStyle={setRowStyle}
					print={{ printHeader: { company: companyName, title: "Compañía", user: userName } }}
				/>
			</div>

			{openSettingCrud && (
				<SettingCrud
					tableValue={tableValue}
					refresh={refresh}
					onClose={() => {
						setOpenSettingCrud(false);
					}}
					modalCrud={modalOption}
					currentCompanyId={tableValue.id}
				/>
			)}
		</Screen>
	);
};
function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.fullName,
		companyName: company.name,
	};
}

Company.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
};
export default connect(mapStateToProps)(Company);
